import { CtaButton } from "@/components/CtaButton";
import { Reveal } from "@/components/Reveal";
import { LeopardStrip } from "@/components/Leopard";
import { site } from "@/config/site.config";

export const FinalCloseSection = () => (
  <section data-testid="final-close-section" className="relative overflow-hidden">
    <img
      src="/assets/dasha-dreamlife.jpg"
      alt="Dasha Love living the vision — freedom, home, life"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover object-top"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-ink/85 via-ink/55 to-ink/90" />
    <div className="relative mx-auto flex min-h-[92vh] max-w-3xl flex-col items-center justify-center px-5 py-24 text-center">
      <Reveal>
        <h2 className="text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl">
          YOU ALREADY KNOW
          <br />
          THERE’S <span className="font-serif italic font-medium text-lime">MORE.</span>
        </h2>
      </Reveal>

      <Reveal className="mt-8 space-y-1.5" delay={0.1}>
        {["More of you.", "More life.", "More love.", "More creation.", "More pleasure.", "More wealth.", "More freedom."].map((l) => (
          <p key={l} className="font-serif text-lg italic text-cream/80 sm:text-xl">{l}</p>
        ))}
      </Reveal>

      <Reveal className="mt-10" delay={0.15}>
        <p className="text-sm text-cream/70 sm:text-base">
          The question isn’t whether you’re capable of it.
        </p>
        <p className="mt-4 text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl">
          ARE YOU WILLING
          <br />
          TO <span className="font-serif italic font-medium text-lime">CHOOSE IT?</span>
        </p>
      </Reveal>

      <Reveal className="mt-10" delay={0.2}>
        <p className="font-mono text-[11px] tracking-[0.35em] text-cream/70">
          WILD WOMAN MILLIONS™
        </p>
        <p className="mt-3 font-mono text-xs leading-relaxed tracking-[0.3em] text-lime">
          SEE IT. CHOOSE IT. PRACTICE IT. HOLD IT. LIVE IT.
        </p>
        <div className="mt-8">
          <CtaButton id="close">I’M READY TO LIVE MY VISION — {site.price}</CtaButton>
        </div>
      </Reveal>
    </div>
    <LeopardStrip className="absolute inset-x-0 bottom-0 h-3 sm:h-4" />
  </section>
);
